var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rb-modal",
    {
      class: _vm.$style.dialog,
      attrs: { options: _vm.modalOptions },
      on: {
        cancel: function ($event) {
          return _vm.cancel()
        },
        hide: function ($event) {
          return _vm.submit()
        },
      },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Decline to rebid"),
      ]),
      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
        _vm._v(
          " You have chosen to decline to rebid. Are you sure you want to continue? "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }